import { gql } from 'graphql-request';

import type { SEO } from '@/types/seo';

import { postFragment } from '../news/post-fragment';
import { mapSingle } from '../news/single';
import type { News } from '../news/types';

interface NewsPageContent extends SEO {
  featuredPost?: News;
}

export const createNewsPageQuery = () => gql`
  ${postFragment}
  query getNewsPage {
    NewsPage {
      featuredPost {
        ...postFragment
      }
      seo {
        title
        description
        image {
          url
        }
      }
    }
  }
`;

export const mapToNewsPageContent = (data: any): NewsPageContent => {
  return {
    ...(data.NewsPage?.featuredPost && {
      featuredPost: mapSingle(data.NewsPage.featuredPost),
    }),
    seo: data.NewsPage.seo,
  };
};
